import React, { Fragment, useRef } from "react";
import { useEffectOnce } from "../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import { DataConsumptionPageBody } from "./dataconsumptionpagebody";
import { 
    setProcessing, setPanes, setFormServerErrors, setFormValue,
    loadPage, saveEntity,
    disposePage 
} from "../../redux/slices/dataconsumptionpageslice";
import { notificationDurationMiddle, deepCompare } from "../../lib/utils";
import { setCurrentPageIsDirty, setCurrentPage } from "../../redux/slices/currentpageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { hideAppDialog, setAppDialog } from "../../redux/slices/appdialogslice";
import { useNavigate, useLocation } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { Page } from "../page";
import { BLOCK_DIRTY_MESSAGE } from "../../settings";
import i18next from "i18next";
import { useTranslation } from "react-i18next";


import "./dataconsumptionpage.css";



export const DataConsumptionPage = props => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser);
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.usersPage);
    const currentPageState = useSelector(state => state.currentPage);
    const navigate = useNavigate();

    const { t } = useTranslation();

    let currentPageId = "dataConsumptionPage";

    /*block navigation if dirty*/
    const updateDirtyState = () => {
        let isDirty = pageState.isPageDirty;

        dispatch(setCurrentPageIsDirty(isDirty));
    };

    const blockNavigationIfDirty = (msg) => {
        if (currentPageState.isPageDirty)
        {
            if (window.confirm(msg ? msg : BLOCK_DIRTY_MESSAGE) == true)
                {
                    dispatch(setCurrentPageIsDirty(false));
                    return false;
                }
            else
                return true;
        }
        else
            return false;
    };
    /*block navigation if dirty*/

    /*initial page load*/
    useEffectOnce(() => {
        dispatch(loadPage(t)).then(
            response => {                
                dispatch(setCurrentPage({id: currentPageId, isDirty: false}));
            },
            err =>{
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                        dispatch(addNotification({text: t("dataconsumption.loading_errormessage"), type: "error", closable: true, duration:3, position:"topRight"}));
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);
                        dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:3, position:"topRight"}));
                    }

                    //go home
                    navigate("/", {replace: true});
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    dispatch(addNotification({text: t("dataconsumption.unknown_error"), type:"error", closable: true, duration: 3, position: "topRight"}));
                    navigate("/", {replace: true});
                };

                //console.log(action);
                apiErrorsHandler({}, dispatch, navigate, err, "/", {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
            }
        );

        return () => {
            dispatch(setCurrentPage({id: "", isDirty: false}));
            dispatch(disposePage(true));
        }
    }, []);
    /*initial load*/


    const handleOnSave = e =>{
        //no client errors => proceed
        dispatch(saveEntity(t)).then(
            response =>{
                dispatch(setCurrentPageIsDirty(false));
            },
            err =>
            {
                //hide loader
                dispatch(setProcessing({processing: false}));

                const handleResponseReceived = (state, dispatch, navigate, payload) =>{
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                        dispatch(addNotification({text: t("dataconsumption.unknown_error1"), type: "error", closable: true, duration: notificationDurationMiddle, position:"topRight"}));
                    else
                    {
                        errorMessages = getErrorMessages(errorMessages, 1);
                        dispatch(addNotification({text: errorMessages[0], type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                    }
                };

                const handleUnhandled = (state, dispatch, navigate, payload) =>{
                    dispatch(addNotification({text: t("dataconsumption.unknown_error1"), type:"error", closable: true, duration: notificationDurationMiddle, position: "topRight"}));
                };

                apiErrorsHandler({}, dispatch, navigate, err, null, {responseReceived: handleResponseReceived, unhandled: handleUnhandled});
            }
        );
    };

    return (
        <Fragment>
            <Page id="dataConsumptionPage" className="dataconsumption-page" title={t("dataconsumption.dataconsumption")} animation={props.animation}>
                <DataConsumptionPageBody onSave={handleOnSave} />
            </Page>
            <style>
                {
                    `
                    /*page class*/
                    .dataconsumption-page
                    {
                        background-color: transparent;
                        padding: 16px;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};